import moment from 'moment'

const getFormattedDate = (duration, unitOfTime) => ({
  startDate: moment()
    .subtract(duration, unitOfTime)
    .format('YYYY-MM-DD'),
  endDate: moment()
    .add(1, 'days')
    .format('YYYY-MM-DD')
})

export default {
  0: {
    name: 'AccountStatement',
    options: [
      { text: '7 dias', value: getFormattedDate(7, 'days') },
      { text: '15 dias', value: getFormattedDate(15, 'days') },
      { text: '1 mês', value: getFormattedDate(1, 'months') },
      { text: '3 meses', value: getFormattedDate(3, 'months') },
      { text: '6 meses', value: getFormattedDate(6, 'months') },
      { text: '1 ano', value: getFormattedDate(1, 'years') },
      { text: '+ de 1 ano', value: getFormattedDate(20, 'years') }
    ]
  },
  1: {
    name: 'Expirations',
    options: [
      { text: '7 dias', value: '0' },
      { text: '15 dias', value: '1' },
      { text: '1 mês', value: '2' },
      { text: '3 meses', value: '4' },
      { text: '6 meses', value: '5' },
      { text: '1 ano', value: '6' }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/Participant/Extract/Details/tabs.js